import React, { Component } from "react";
import API from '../../utils/api';
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import FabAdd from "../../components/FabAdd";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";

import { getCurrentOrg, api2ClassesByOrganizationId } from "../../utils/operations.js";
import { observer, inject } from "mobx-react";

class Classes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showProgress: true,
    };
  }

  componentDidMount() {
    this.loadData(this.props.Auth.orgId);
  }

  loadData = (orgId) => {
    API.get(getCurrentOrg + orgId).then(res => {
      const orgName = res.data.name;
      API.get(api2ClassesByOrganizationId(orgId)).then(res2 => {
        const data = res2.data.data.map(row => ({ ...row, organisation: orgName }));
        this.setState({ showProgress: false, data });
      });
    });
  };

  editData = (id) => {
    this.props.history.push("/editclasses/" + id);
  };

  newClasses = () => {
    this.props.history.push("/newclasses");
  };

  render() {
    const { data, showProgress } = this.state;

    return (
      <div style={{ maxWidth: 480, margin: "auto", paddingTop: 16 }}>
        {showProgress && <LinearProgress />}
        <Paper variant="outlined">
          <List
            subheader={
              <ListSubheader sx={{ fontWeight: 600, fontSize: 16, borderBottom: "1px solid #e0e0e0" }}>
                Classes
              </ListSubheader>
            }
            disablePadding
          >
            {data.map((row, index) => (
              <ListItemButton
                key={row.id}
                onClick={() => this.editData(row.id)}
                divider={index < data.length - 1}
              >
                <ListItemText primary={row.name} />
              </ListItemButton>
            ))}
          </List>
        </Paper>
        {this.props.Auth.can('classes_edit') && <FabAdd onClick={this.newClasses} />}
      </div>
    );
  }
}

export default inject("Auth")(observer(Classes));
